import { useSearchParams } from 'react-router-dom';
import { ChatTabType } from '../types';

export const useUserChatQueryParams = () => {
	const [searchParams] = useSearchParams();

	// Get channelId from either 'channel' or 'channelId' query param
	// This supports both formats for backward compatibility
	const channelId = searchParams.get('channelId') || searchParams.get('channel') || '';
	const tabType = (searchParams.get('tab') as ChatTabType) || ChatTabType.Direct;

	return {
		channelId,
		tabType,
	};
};
